import React from 'react'

export default ({ ...props }) => (
  <svg
    width='1041'
    height='196'
    viewBox='0 0 1041 196'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clip-path='url(#clip0_395_186)'>
      <path
        d='M179.458 113.078L92.8117 164.884L90.9958 165.978L89.1799 164.884L2.49184 113.078L0.985474 112.169V144.814L80.0592 192.077C83.4227 194.08 87.1989 195.092 90.9752 195.092C94.7514 195.092 98.5276 194.08 101.891 192.077L180.965 144.814V112.169L179.458 113.078Z'
        fill='black'
      />
      <path
        d='M2.47121 82.106L89.1386 30.3001L90.9545 29.2058L92.7704 30.3001L179.417 82.106L180.924 83.0145V50.37L101.891 3.10665C98.5276 1.10379 94.7514 0.092041 90.9752 0.092041C87.1989 0.092041 83.4227 1.10379 80.0592 3.10665L0.964844 50.37V83.0145L2.47121 82.106Z'
        fill='black'
      />
      <path
        d='M129.274 81.1562L92.7704 102.981L90.9545 104.075L89.1386 102.981L2.49184 51.1959L0.985474 50.2874V82.9319L80.0592 130.195C83.4227 132.198 87.1989 133.21 90.9752 133.21C94.7514 133.21 98.5276 132.198 101.891 130.195L156.471 97.5507L129.274 81.1768V81.1562Z'
        fill='black'
      />
    </g>
    <path
      d='M304.686 147.936C278.628 147.936 256.527 131.291 256.527 97.5932C256.527 66.6236 278.219 47.387 305.096 47.387C328.425 47.387 346.025 60.2114 349.708 82.5859H329.653C327.334 71.1258 317.647 63.3493 304.823 63.3493C287.906 63.3493 275.218 76.583 275.218 97.5932C275.218 118.194 287.223 131.837 305.914 131.837C321.058 131.837 331.017 122.696 331.972 109.872H302.367V95.001H349.299V146.844H332.518V134.02C328.152 142.206 316.965 147.936 304.686 147.936Z'
      fill='black'
    />
    <path
      d='M406.967 91.7267C404.921 91.3174 402.738 90.9081 400.146 90.9081C390.186 90.9081 380.909 99.5032 380.909 120.786V146.844H363.719V76.0373H380.909V88.9981C384.047 80.9487 393.597 74.9458 402.192 74.9458C404.239 74.9458 405.603 75.0823 406.967 75.3551V91.7267Z'
      fill='black'
    />
    <path
      d='M465.931 135.657C459.791 143.434 449.832 147.936 438.645 147.936C422.955 147.936 412.859 139.341 412.859 127.471C412.859 115.056 421.727 107.416 437.417 105.37L451.742 103.46C455.426 102.914 457.336 101.004 457.336 97.8661C457.336 92.6817 452.288 88.316 443.965 88.316C436.325 88.316 430.05 92.4089 429.64 99.6397H413.542C415.042 84.4959 426.23 74.9458 443.965 74.9458C454.471 74.9458 462.929 78.3566 468.114 84.3595C473.844 78.6294 481.893 74.9458 492.398 74.9458C515.591 74.9458 526.778 92.4089 526.778 109.463C526.778 112.328 526.506 115.466 526.506 115.466H474.799C476.163 126.926 483.257 133.474 493.762 133.474C501.539 133.474 507.678 129.791 509.179 123.651H526.233C523.913 139.068 510.816 147.936 493.353 147.936C481.074 147.936 471.934 143.024 465.931 135.657ZM440.418 135.111C451.333 135.111 457.745 127.062 457.745 116.421V114.374L440.282 117.239C433.324 118.331 429.913 121.605 429.913 126.789C429.913 131.564 434.006 135.111 440.418 135.111ZM475.344 102.778H508.224C507.542 94.1825 501.948 88.0431 492.398 88.0431C483.394 88.0431 477.527 93.3639 475.344 102.778Z'
      fill='black'
    />
    <path
      d='M538.184 146.844V76.0373H555.374V86.9517C560.013 79.7209 568.062 74.9458 578.022 74.9458C593.302 74.9458 603.671 85.0416 603.671 100.458V146.844H586.617V104.415C586.617 96.0925 581.296 90.226 572.974 90.226C561.787 90.226 555.374 99.7761 555.374 115.738V146.844H538.184Z'
      fill='black'
    />
    <path
      d='M634.822 146.844L608.901 76.0373H626.227L642.872 127.062L659.38 76.0373H676.707L650.921 146.844H634.822Z'
      fill='black'
    />
    <path
      d='M703.352 147.936C689.027 147.936 678.658 139.341 678.658 127.471C678.658 115.056 687.662 107.416 703.352 105.37L717.541 103.46C721.361 102.914 723.271 101.004 723.271 97.8661C723.271 92.6817 718.223 88.316 709.901 88.316C702.124 88.316 696.258 92.4089 695.712 99.6397H679.067C680.705 84.4959 692.165 74.9458 709.901 74.9458C728.591 74.9458 740.461 85.5874 740.461 102.368V127.335C740.461 131.291 741.962 133.065 744.963 133.065C745.782 133.065 746.6 132.929 747.146 132.792V146.844C745.509 147.254 742.371 147.663 738.96 147.663C731.729 147.663 726.409 144.252 725.59 137.567C722.452 143.843 713.857 147.936 703.352 147.936ZM706.217 134.839C717.268 134.839 723.68 126.926 723.68 116.284V114.238L706.217 117.103C699.259 118.194 695.848 121.468 695.848 126.653C695.848 131.428 699.941 134.839 706.217 134.839Z'
      fill='black'
    />
    <path
      d='M756.152 146.844V76.0373H773.343V86.9517C777.981 79.7209 786.031 74.9458 795.99 74.9458C811.27 74.9458 821.639 85.0416 821.639 100.458V146.844H804.585V104.415C804.585 96.0925 799.264 90.226 790.942 90.226C779.755 90.226 773.343 99.7761 773.343 115.738V146.844H756.152Z'
      fill='black'
    />
    <path
      d='M868.156 173.448C848.919 173.448 835.959 164.717 833.776 148.209H851.102C852.057 155.303 858.333 159.669 868.156 159.669C878.798 159.669 885.346 153.802 885.346 143.979V135.111C881.936 139.886 874.432 143.297 865.564 143.297C845.099 143.297 832.411 129.518 832.411 109.19C832.411 88.7253 845.099 74.9458 865.155 74.9458C873.75 74.9458 881.253 78.493 885.346 83.8138V76.0373H902.536V142.206C902.536 161.579 889.166 173.448 868.156 173.448ZM868.156 128.563C879.207 128.563 886.301 120.923 886.301 109.19C886.301 97.5932 879.207 89.8167 868.156 89.8167C857.105 89.8167 849.875 97.4568 849.875 109.19C849.875 120.923 857.105 128.563 868.156 128.563Z'
      fill='black'
    />
    <path
      d='M982.171 76.0373V146.844H964.981V135.93C960.342 143.161 952.157 147.936 942.334 147.936C926.917 147.936 916.548 137.84 916.548 122.423V76.0373H933.738V118.467C933.738 126.789 939.059 132.656 947.381 132.656C958.432 132.656 964.981 123.106 964.981 107.143V76.0373H982.171Z'
      fill='black'
    />
    <path
      d='M1040.28 91.7267C1038.24 91.3174 1036.06 90.9081 1033.46 90.9081C1023.5 90.9081 1014.23 99.5032 1014.23 120.786V146.844H997.037V76.0373H1014.23V88.9981C1017.36 80.9487 1026.91 74.9458 1035.51 74.9458C1037.56 74.9458 1038.92 75.0823 1040.28 75.3551V91.7267Z'
      fill='black'
    />
    <defs>
      <clipPath id='clip0_395_186'>
        <rect
          width='180'
          height='195'
          fill='white'
          transform='translate(0.964844 0.092041)'
        />
      </clipPath>
    </defs>
  </svg>
)
